module.exports = __webpack_public_path__ + "static/media/icon-video-disconnect.377f4b7b.svg";